import React from 'react';
import { Form } from 'react-bootstrap';
import './AgreementCheckbox.css';

const AgreementCheckbox = ({ register, errors }) => {
  return (
    <Form.Group className="mb-3">
      <Form.Check
        type="checkbox"
        id="agree-checkbox"
        className="form-check-label ms-0"
        isInvalid={!!errors.agree}
        {...register('agree', { required: true })}
        label={
          <span className="small">
            By clicking, I agree to the <a href='../../legal/privacyPolicy.html' target='_blank'>Privacy Policy</a> and <a href='../../legal/termsOfService.html' target='_blank'>Terms of Service</a>
          </span>
        }
      />
      {errors.agree && (
        <Form.Control.Feedback type="invalid" style={{ display: 'block' }}>
          You must agree before submitting.
        </Form.Control.Feedback>
      )}
    </Form.Group>
  );
};

export default AgreementCheckbox;